// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={114}
    height={122}
    viewBox="0 0 114 122"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1688_28915)">
      <rect
        x={12.7481}
        y={51.4695}
        width={64.1773}
        height={52.3821}
        rx={5.71573}
        transform="rotate(-33.0053 12.7481 51.4695)"
        fill="#FF73A9"
        stroke="#29292F"
        strokeWidth={0.696113}
      />
      <rect
        x={16.8267}
        y={52.3367}
        width={58.2797}
        height={46.4846}
        rx={2.68383}
        transform="rotate(-33.0053 16.8267 52.3367)"
        fill="#FFD5E1"
        stroke="#29292F"
        strokeWidth={0.696113}
      />
      <rect
        x={40.5747}
        y={61.8289}
        width={8.15026}
        height={21.163}
        rx={2.68383}
        transform="rotate(-33.0053 40.5747 61.8289)"
        fill="#FCFBF7"
        stroke="#29292F"
        strokeWidth={0.696113}
      />
      <rect
        x={53.9302}
        y={63.446}
        width={8.15026}
        height={12.5344}
        rx={2.68383}
        transform="rotate(-33.0053 53.9302 63.446)"
        fill="#FCFBF7"
        stroke="#29292F"
        strokeWidth={0.696113}
      />
      <rect
        x={36.6197}
        y={74.6882}
        width={8.15026}
        height={12.5344}
        rx={2.68383}
        transform="rotate(-33.0053 36.6197 74.6882)"
        fill="#FCFBF7"
        stroke="#29292F"
        strokeWidth={0.696113}
      />
      <rect
        x={60.7051}
        y={54.9265}
        width={8.15026}
        height={15.9858}
        rx={2.68383}
        transform="rotate(-33.0053 60.7051 54.9265)"
        stroke="#29292F"
        strokeWidth={0.696113}
        strokeDasharray="1.52 1.52"
      />
      <rect
        x={64.6602}
        y={42.071}
        width={8.15026}
        height={24.6144}
        rx={2.68383}
        transform="rotate(-33.0053 64.6602 42.071)"
        stroke="#29292F"
        strokeWidth={0.696113}
        strokeDasharray="1.52 1.52"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.4308 29.889C62.5689 29.5037 62.5318 29.0606 62.2917 28.6909C61.8834 28.0624 61.0429 27.8838 60.4144 28.292C60.1444 28.4674 59.9575 28.7225 59.8644 29.0062L50.1375 50.2129L38.3347 48.2111C37.6828 48.1006 37.0468 48.4782 36.8317 49.1034L32.2575 62.4027C32.0688 62.8118 32.0878 63.3059 32.3513 63.7116C32.7596 64.3401 33.6 64.5187 34.2286 64.1105C34.5316 63.9136 34.7301 63.6163 34.8086 63.2907L39.0132 51.066L50.7073 53.0493C51.3099 53.1515 51.906 52.8363 52.1608 52.2808L62.3361 30.0965C62.3727 30.0313 62.4038 29.9635 62.4291 29.8938L62.4312 29.8892L62.4308 29.889Z"
        fill="#FCFBF7"
      />
      <path
        d="M62.4308 29.889L62.1031 29.7716L61.9954 30.0721L62.2855 30.2053L62.4308 29.889ZM59.8644 29.0062L60.1808 29.1514L60.189 29.1335L60.1951 29.1147L59.8644 29.0062ZM50.1375 50.2129L50.0793 50.556L50.3425 50.6007L50.4539 50.358L50.1375 50.2129ZM38.3347 48.2111L38.2765 48.5543L38.2765 48.5543L38.3347 48.2111ZM36.8317 49.1034L37.1608 49.2166L36.8317 49.1034ZM32.2575 62.4027L32.5735 62.5485L32.5809 62.5325L32.5866 62.5159L32.2575 62.4027ZM34.8086 63.2907L34.4794 63.1775L34.4741 63.193L34.4702 63.2091L34.8086 63.2907ZM39.0132 51.066L39.0714 50.7228L38.7802 50.6734L38.6841 50.9528L39.0132 51.066ZM50.7073 53.0493L50.7655 52.7061L50.7073 53.0493ZM52.1608 52.2808L51.8444 52.1357L52.1608 52.2808ZM62.3361 30.0965L62.0327 29.9258L62.0257 29.9383L62.0197 29.9513L62.3361 30.0965ZM62.4291 29.8938L62.1127 29.7488L62.1067 29.7617L62.1019 29.7751L62.4291 29.8938ZM62.4312 29.8892L62.7476 30.0343L62.8925 29.7181L62.5764 29.5729L62.4312 29.8892ZM61.9998 28.8805C62.1782 29.1552 62.2062 29.4842 62.1031 29.7716L62.7584 30.0065C62.9316 29.5233 62.8854 28.966 62.5835 28.5013L61.9998 28.8805ZM60.604 28.5839C61.0713 28.2804 61.6962 28.4132 61.9998 28.8805L62.5835 28.5013C62.0706 27.7116 61.0145 27.4872 60.2248 28.0002L60.604 28.5839ZM60.1951 29.1147C60.2644 28.9037 60.403 28.7145 60.604 28.5839L60.2248 28.0002C59.8859 28.2203 59.6506 28.5413 59.5337 28.8977L60.1951 29.1147ZM59.548 28.8611L49.8211 50.0678L50.4539 50.358L60.1808 29.1514L59.548 28.8611ZM50.1957 49.8697L38.3929 47.868L38.2765 48.5543L50.0793 50.556L50.1957 49.8697ZM38.3929 47.868C37.573 47.7289 36.7731 48.2039 36.5026 48.9902L37.1608 49.2166C37.3205 48.7525 37.7926 48.4722 38.2765 48.5543L38.3929 47.868ZM36.5026 48.9902L31.9284 62.2895L32.5866 62.5159L37.1608 49.2166L36.5026 48.9902ZM31.9414 62.2569C31.7047 62.7699 31.7281 63.3911 32.0594 63.9012L32.6432 63.522C32.4474 63.2207 32.4328 62.8536 32.5735 62.5485L31.9414 62.2569ZM32.0594 63.9012C32.5724 64.6909 33.6284 64.9153 34.4182 64.4023L34.039 63.8186C33.5716 64.1221 32.9467 63.9893 32.6432 63.522L32.0594 63.9012ZM34.4182 64.4023C34.7988 64.1551 35.0484 63.7809 35.1469 63.3722L34.4702 63.2091C34.4117 63.4516 34.2644 63.6721 34.039 63.8186L34.4182 64.4023ZM35.1377 63.4039L39.3423 51.1792L38.6841 50.9528L34.4794 63.1775L35.1377 63.4039ZM38.955 51.4091L50.6491 53.3924L50.7655 52.7061L39.0714 50.7228L38.955 51.4091ZM50.6491 53.3924C51.407 53.521 52.1567 53.1246 52.4771 52.4259L51.8444 52.1357C51.6553 52.548 51.2128 52.782 50.7655 52.7061L50.6491 53.3924ZM52.4771 52.4259L62.6525 30.2416L62.0197 29.9513L51.8444 52.1357L52.4771 52.4259ZM62.1019 29.7751C62.083 29.827 62.0599 29.8775 62.0327 29.9258L62.6395 30.2671C62.6855 30.1852 62.7245 30.1 62.7562 30.0125L62.1019 29.7751ZM62.7454 30.0389L62.7476 30.0343L62.1148 29.7441L62.1127 29.7488L62.7454 30.0389ZM62.5764 29.5729L62.576 29.5727L62.2855 30.2053L62.2859 30.2055L62.5764 29.5729Z"
        fill="#29292F"
      />
    </g>
    <path
      d="M60.6816 88.1602C64.9156 98.6696 76.8674 103.757 87.3769 99.523C97.8863 95.2891 101.877 89.8273 101.877 89.8273"
      stroke="black"
      strokeWidth={0.696113}
    />
    <path
      d="M85.181 92.8749C78.2516 95.6665 70.3712 92.3122 67.5796 85.3828"
      stroke="black"
      strokeWidth={0.696113}
    />
    <defs>
      <clipPath id="clip0_1688_28915">
        <rect
          width={70.771}
          height={70.771}
          fill="white"
          transform="translate(5.37598 46.1719) rotate(-33.0053)"
        />
      </clipPath>
    </defs>
  </svg>
);
const SvgTrending = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgTrending;
